import { useState, useEffect } from 'react';
import { buildQuery } from '../utils/influenceScorecard';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// state: {loading, error, data}. data.available === false is a normal empty state, not an error.
export default function useInfluenceScorecard(filters) {
  const [state, setState] = useState({ loading: true, error: null, data: null });
  const query = buildQuery(filters || {});
  useEffect(() => {
    let live = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    fetch(`${API_BASE_URL}/exec/influence/scorecard?${query}`, { credentials: 'include' })
      .then((r) => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then((data) => { if (live) setState({ loading: false, error: null, data }); })
      .catch((e) => { if (live) setState({ loading: false, error: e.message, data: null }); });
    return () => { live = false; };
  }, [query]);
  return state;
}
